import { Components, createTheme } from '@mui/material';
import lightPalette from './palettes/light';
import typography from './typography';

const theme = createTheme({ palette: lightPalette, typography });
const components: Components = {
  MuiCssBaseline: {
    styleOverrides: {
      '*, *::before, *::after': {
        boxSizing: 'border-box',
      },
      body: {
        minWidth: 1200,
      },
      a: {
        textDecoration: 'none',
        color: theme.palette.primary.main,
      },
      p: {
        marginTop: 0,
      },
    },
  },
  MuiButtonBase: {
    defaultProps: {
      disableRipple: true,
    },
  },
  MuiButton: {
    defaultProps: {
      disableElevation: true,
      disableRipple: true,
    },
    styleOverrides: {
      root: {
        ...typography.button,
        padding: theme.spacing(0.5, 3.75),
        lineHeight: '24px',
        borderRadius: 4,
      },
      sizeSmall: {
        padding: theme.spacing(0.5, 1.25),
      },
      sizeLarge: {
        minWidth: 200,
        padding: theme.spacing(2, 4),
        ...theme.typography.button_lg,
      },
      outlined: {
        padding: theme.spacing(0.25, 3.25),
        '&, &:hover': {
          borderWidth: 2,
        },
      },
      outlinedSecondary: {
        borderColor: theme.palette.secondary.main,
        color: theme.palette.secondary.main,
      },
      outlinedSizeSmall: {
        padding: theme.spacing(0.25, 1),
      },
      outlinedSizeLarge: {
        padding: theme.spacing(1.75, 3.75),
      },
      startIcon: {
        marginLeft: 0,
        marginRight: 4,
      },
      endIcon: {
        marginLeft: 4,
        marginRight: 0,
      },
    },
  },
  MuiToolbar: {
    styleOverrides: {
      root: {
        [theme.breakpoints.up('sm')]: {
          minHeight: 60,
        },
      },
    },
  },
  MuiChip: {
    styleOverrides: {
      root: {
        padding: theme.spacing(0.625, 1),
        height: 'auto',
        borderRadius: 4,
      },
      label: {
        ...theme.typography.button_sm,
        padding: 0,
      },
    },
  },
  MuiRadio: {
    styleOverrides: {
      root: {
        padding: 0,
        marginRight: theme.spacing(1),
      },
    },
  },
  MuiCard: {
    defaultProps: {
      elevation: 0,
    },
    styleOverrides: {
      root: {
        border: `1px solid ${theme.palette.grey[100]}`,
        borderRadius: 8,
      },
    },
  },
  MuiCardContent: {
    styleOverrides: {
      root: {
        '&:last-child': {
          paddingBottom: theme.spacing(2),
        },
      },
    },
  },
  MuiInputLabel: {
    styleOverrides: {
      root: {
        position: 'static',
        transform: 'none',
        ...typography.subtitle2,
        marginBottom: theme.spacing(0.5),
      },
      sizeSmall: {
        ...typography.subtitle3,
      },
    },
  },
  MuiOutlinedInput: {
    defaultProps: {
      notched: true,
    },
    styleOverrides: {
      root: {
        borderRadius: 4,
        padding: theme.spacing(0.375),
        backgroundColor: theme.palette.common.white,
      },
      notchedOutline: {
        borderColor: theme.palette.grey[100],
        top: 0,
        '& legend': {
          display: 'none',
        },
      },
      input: {
        padding: theme.spacing(0.625),
        'label[data-shrink=false]+.MuiInputBase-formControl &::-webkit-input-placeholder': {
          opacity: '.4 !important',
        },
      },
    },
  },
  MuiInputBase: {
    styleOverrides: {
      root: {
        ...typography.body2,
        height: 48,
      },
      sizeSmall: {
        ...typography.body3,
        height: 32,
      },
      input: {},
      inputMultiline: {
        '.MuiInputBase-multiline &': {
          padding: theme.spacing(1.5),
        },
      },
      multiline: {
        height: 'auto',
      },
    },
  },
  MuiInputAdornment: {
    styleOverrides: {
      root: {
        height: 'auto',
      },
      positionEnd: {
        marginRight: 8,
      },
    },
  },
  MuiDialog: {
    styleOverrides: {
      paper: {
        padding: 32,
      },
    },
  },
};

export default components;
